module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_5_001.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "toc1"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/005_Chapter_1"
    }
  }, [_vm._v("Timeline of Events")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/006_Chapter_2"
    }
  }, [_vm._v("Prelude to the Great Patriotic War")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_3"
    }
  }, [_vm._v("The Red Air Force")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Luftwaffe")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Barbarossa")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soviet Counteroffensives")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fall of the Fatherland")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aftermath")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Reading")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0